import { type AppInfo } from '../../../types';
import { useEmbeddedCopy, useAnotherApp } from '../../../hooks/useEmbeddedCopy';
import EmbeddedStatusScreen from './StatusScreen';

/** "Sharing didn't finish" with Try again, and its "Why?" answer. */
export default function EmbeddedErrorScreen({
  app,
  onRetry,
  onBack,
  onWhy,
}: {
  app?: AppInfo;
  onRetry?: () => void;
  onBack?: () => void;
  onWhy?: () => void;
}) {
  const { t, pick } = useEmbeddedCopy();
  const appName = app?.name ?? '';
  return (
    <EmbeddedStatusScreen
      visual="app"
      app={app}
      badge="x"
      title={t(pick('embedded.error.title', 'embedded.error.titleIssuance'))}
      sub={t(pick('embedded.error.sub', 'embedded.error.subIssuance'), {
        app: appName,
      })}
      primary={onRetry && { label: t('embedded.tryAgain'), onClick: onRetry }}
      secondary={useAnotherApp(onBack)}
      links={onWhy && [{ label: t('embedded.error.help'), onClick: onWhy }]}
    />
  );
}
